import React, { useState } from "react";
import { modalStyles } from "../../theme/theme";
import CloseButton from "../closeButton/CloseButton";
import EditableContent from "./editableContent/EditableContent";
import DescriptionContent from "./descriptionContent/DescriptionContent";
import OrderContent from "./orderContent/OrderContent";
import { ReactComponent as EditPen } from "../../assets/images/svg/editPen.svg";

const Modal = (props) => {
  const {
    toggle,
    modalVisible,
    products,
    title,
    handleClick,
    index,
    setProducts,
    content,
    isAdmin,
    editOrderToggleModal,
  } = props;
  const [modalTitle, setModalTitle] = useState("");

  return (
    <div
      className={
        modalVisible ? modalStyles["overlayShow"] : modalStyles["overlayHide"]
      }
    >
      <div
        className={`${
          content !== "order" && "min-h-modal-mobile tablet:min-h-modal-h "
        } mx-5 z-50 relative  my-auto w-11/12  tablet:mx-auto max-w-50rem desktop:w-50rem   flex flex-col bg-white rounded-32`}
      >
        {isAdmin ? (
          <div className=" [height:104px] rounded-t-32   px-14 bg-primary flex flex-row items-center justify-center gap-8 ">
            <h2 className="font-bold text-lg desktop:text-2xl text-white">
              {title ? title : modalTitle}
            </h2>
            <div className="flex-grow mx-4 border-t border-white opacity-1"></div>

            <div>
              <button
                className="flex items-center gap-1 underline"
                onClick={editOrderToggleModal}
              >
                <span>Edit order</span>
                <EditPen />
              </button>
            </div>
            <CloseButton
              currentColor="white"
              onClick={toggle}
              className="relative"
            />
          </div>
        ) : (
          <div className=" h-24 rounded-t-32 min-h-6rem desktop:min-h-9rem desktop:h-36 px-14 bg-primary flex flex-col items-start justify-center relative ">
            <h2 className="font-bold text-lg desktop:text-2xl text-white">
              {title ? title : modalTitle}
            </h2>
            <CloseButton
              className=" top:7 right-7 absolute"
              currentColor="white"
              onClick={toggle}
            />
          </div>
        )}

        {content === "details" && (
          <DescriptionContent
            setTitle={setModalTitle}
            products={products}
            index={index}
          />
        )}
        {content === "order" && (
          <OrderContent index={index} orders={products} />
        )}

        {content === "edit" && setProducts && handleClick ? (
          <EditableContent
            setTitle={setModalTitle}
            products={products}
            index={index}
            toggle={toggle}
            setProducts={setProducts}
            handleClick={handleClick}
            title={title}
          />
        ) : null}
      </div>
    </div>
  );
};

export default Modal;
